import React from "react";
import { FacilityOrderTemplateNewFlowInsuranceEditTemplate } from "themes/application/facility-order-new-flow-insurance/components";
import { observer } from "mobx-react";

@observer
class FacilityOrderTemplateNewFlowInsuranceEdit extends React.Component {
	render() {
		return <FacilityOrderTemplateNewFlowInsuranceEditTemplate {...this.props} />;
	}
}

export default FacilityOrderTemplateNewFlowInsuranceEdit;